import { render, staticRenderFns } from "./BuildingsOtherSourcesChart.vue?vue&type=template&id=59251c09&scoped=true&"
import script from "./BuildingsOtherSourcesChart.vue?vue&type=script&lang=js&"
export * from "./BuildingsOtherSourcesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59251c09",
  null
  
)

export default component.exports